import React, { useRef, useState } from 'react';
import './SettingPswd.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Link } from 'react-router-dom';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';

const SettingPswd = () => {
    const { user } = useAuth();
    const username = user.user;
    const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

    const [successMessage, setSuccessMessage] = useState('');
    const [otpMessage, setOtpMessage] = useState('');
    const [formData, setFormData] = useState({
        email: username.email || '',
        otp: '',
        password: '',
      });
      
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const handleOtpInputChange = (index, value) => {
        const newFormData = { ...formData };
    
        // Handle backspace
        if (value === '' && index > 0) {
          // If backspace and not the first digit, move focus to the previous input
          const prevIndex = index - 1;
          const prevInput = inputRefs[prevIndex].current;
          if (prevInput) {
            prevInput.focus();
          }
        } else if (index < 3 && value !== '') {
          // If not the last digit and a value is entered, move focus to the next input
          const nextIndex = index + 1;
          const nextInput = inputRefs[nextIndex].current;
          if (nextInput) {
            nextInput.focus();
          }
        }
    
        newFormData.otp = (newFormData.otp || '').split('');
        newFormData.otp[index] = value;
        newFormData.otp = newFormData.otp.join('');
    
        setFormData(newFormData);
      };

      const handleSendOtp = async () => {
        formData.otp = formData.otp.toString();
        const response = await fetch(API_URL+'/sendOtpForProfilepswd', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        
        if (response.ok) {
          const data = await response.json();
          setOtpMessage(data.message);
        }
      };

    const handlePassword = async() => {
        formData.otp = formData.otp.toString();
        try {
            const response = await fetch(API_URL+'/changePassword', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            });
      
            if (response.status === 200) {
             setSuccessMessage('Password changed successfully!')
             window.alert('Password changed successfully!');
             setTimeout(() => {
              sessionStorage.removeItem('user');
              window.location.reload(true);
              window.location.href = '/SignIn'
             }, 2000);
            } else {
              alert('Invalid Otp');
            }
          } catch (error) {
            console.error(error);
          }
    }

return (
        <div className="setting_pswd_page">
            <SideMenuBar />

            <div className="content">
                <NewHeader />

                <main className="setting_pswd_container">
                    <section className="setting_pswd_hero">
                        <div>
                            <span className="setting_pswd_kicker">Account security</span>
                            <h1 className="setting_pswd_title">Settings</h1>
                            <p className="setting_pswd_subtitle">
                                Secure your account by verifying your email before changing your password.
                            </p>
                        </div>

                        <div className="setting_pswd_security">
                            <span>Security status</span>
                            <strong>Verification required</strong>
                            <small>OTP authentication</small>
                        </div>
                    </section>

                    <section className="setting_pswd_panel">
                        <nav className="setting_pswd_tabs" aria-label="Settings sections">
                            <Link to="/SettingsPage" className="setting_pswd_tab">
                                Profile
                            </Link>
                            <Link to="/SettingPswd" className="setting_pswd_tab active">
                                Password
                            </Link>
                            <Link to="/SettingReport" className="setting_pswd_tab">
                                Report
                            </Link>
                        </nav>

                        <div className="setting_pswd_body">
                            <div className="setting_pswd_intro">
                                <span className="setting_pswd_eyebrow">Password recovery</span>
                                <h2>Change your password</h2>
                                <p>
                                    Follow the three steps below to verify your email,
                                    enter the OTP, and create a new password.
                                </p>
                            </div>

                            <div className="setting_pswd_steps">
                                <section className="setting_pswd_step">
                                    <div className="setting_pswd_step_number">01</div>
                                    <div className="setting_pswd_step_content">
                                        <div className="setting_pswd_step_heading">
                                            <div>
                                                <h3>Verify email</h3>
                                                <p>Enter the email address linked to your account.</p>
                                            </div>
                                            <span>Required</span>
                                        </div>

                                        <label htmlFor="setting-email">Email ID</label>
                                        <input
                                            id="setting-email"
                                            className="setting_pswd_email_input"
                                            placeholder="Enter email address"
                                            name="email"
                                            type="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                        />

                                        <button
                                            type="button"
                                            className="setting_pswd_primary_btn setting_pswd_send_btn"
                                            onClick={handleSendOtp}
                                        >
                                            Send OTP
                                        </button>
                                    </div>
                                </section>

                                <section className="setting_pswd_step">
                                    <div className="setting_pswd_step_number">02</div>
                                    <div className="setting_pswd_step_content">
                                        <div className="setting_pswd_step_heading">
                                            <div>
                                                <h3>Enter OTP</h3>
                                                <p>We sent a one-time password to your email.</p>
                                            </div>
                                            <span>4 digits</span>
                                        </div>

                                        <div className="setting_pswd_otp_group">
                                            {[0, 1, 2, 3].map((index) => (
                                                <input
                                                    key={index}
                                                    ref={inputRefs[index]}
                                                    id={`otp-input-${index}`}
                                                    className="setting_pswd_otp_input"
                                                    type="text"
                                                    inputMode="numeric"
                                                    autoComplete="one-time-code"
                                                    maxLength={1}
                                                    aria-label={`OTP digit ${index + 1}`}
                                                    value={(formData.otp || '')[index] || ''}
                                                    onChange={(e) => handleOtpInputChange(index, e.target.value)}
                                                />
                                            ))}
                                        </div>

                                        <div className="setting_pswd_otp_actions">
                                            <button
                                                type="button"
                                                className="setting_pswd_secondary_btn"
                                                onClick={handleSendOtp}
                                            >
                                                Resend OTP
                                            </button>
                                            {otpMessage && (
                                                <span className="setting_pswd_message">
                                                    {otpMessage}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </section>

                                <section className="setting_pswd_step">
                                    <div className="setting_pswd_step_number">03</div>
                                    <div className="setting_pswd_step_content">
                                        <div className="setting_pswd_step_heading">
                                            <div>
                                                <h3>Create new password</h3>
                                                <p>Choose a secure password for your account.</p>
                                            </div>
                                            <span>Final step</span>
                                        </div>

                                        <div className="setting_pswd_password_grid">
                                            <div className="setting_pswd_field">
                                                <label htmlFor="new-password">New Password</label>
                                                <input
                                                    id="new-password"
                                                    className="setting_pswd_password_input"
                                                    type="password"
                                                    placeholder="Enter new password"
                                                    name="password"
                                                    value={formData.password}
                                                    onChange={handleInputChange}
                                                />
                                            </div>

                                            <div className="setting_pswd_field">
                                                <label htmlFor="confirm-password">Confirm Password</label>
                                                <input
                                                    id="confirm-password"
                                                    className="setting_pswd_password_input"
                                                    type="password"
                                                    placeholder="Confirm new password"
                                                    name="password"
                                                    value={formData.password}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>

                                        {successMessage && (
                                            <div className="setting_pswd_success">
                                                {successMessage}
                                            </div>
                                        )}

                                        <div className="setting_pswd_update_row">
                                            <span>Your session will be refreshed after a successful password change.</span>
                                            <button
                                                type="button"
                                                className="setting_pswd_primary_btn"
                                                onClick={handlePassword}
                                            >
                                                Update password
                                            </button>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default SettingPswd;